import * as z from "zod";

const ExternalAccountSchema_ = z.object({
  id: z.string(),
  name: z.string(),
  fullyQualifiedName: z.string(),
  accountType: z.string(),
  accountSubType: z.string(),
  active: z.boolean(),
});

export const getChartOfAccounts = {
  name: "getChartOfAccounts" as const,
  input: z.null(),
  output: z.object({ accounts: z.array(ExternalAccountSchema_) }),
};
